import React, {useEffect, useState, useRef, useContext} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import styles from './MobileMenu.module.css';
import logo_svg from "../../static_files/PrismaxLogoWhite.svg";
import {SwapMainAppContext} from '../../context/SwapMainAppContext';
import {hasRoboticDataAccess, ROBOTIC_DATA_UI_ENABLED} from '../RoboticData/access';

import transImg from '../../static_files/dashboard.svg';
import transImgHover from '../../static_files/dashboardHover.svg';
import roboticDataImg from '../../static_files/roboticdata.svg';
import assetsImg from '../../static_files/robot.svg';
import assetsImgHover from '../../static_files/robotHover.svg';
import inviteImg from '../../static_files/dataset.svg';
import badge_explorer from '../../static_files/badge_explorer.png';
import badge_amplifier from '../../static_files/badge_amplifier.png'
import badge_innovator from '../../static_files/badge_innovator.png'
import bookImg from '../../static_files/bookIcon.svg';
import bookImgHover from '../../static_files/bookIconHover.svg';
import liveControlImg from '../../static_files/live control.svg';
import liveControlImgHover from '../../static_files/live controlHover.svg';

function SideMenu({isOpen, onOverlayClick, stopPropagation}) {
    const location = useLocation();
    const navigate = useNavigate();
    const [isRendered, setIsRendered] = useState(false);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const imagesRef = useRef({});
    const {
        userClass,
        userRole,
        showNotification,
        isQaReviewInProgress,
        requestLeaveQaReviewConfirmation,
    } = useContext(SwapMainAppContext);
    const canAccessRoboticData = hasRoboticDataAccess(userRole);

    useEffect(() => {
        const preloadImages = () => {
            const images = [
                transImg, transImgHover, assetsImg, assetsImgHover,
                roboticDataImg,
                liveControlImg, liveControlImgHover, bookImg, bookImgHover,
                badge_explorer, badge_innovator, badge_amplifier
            ];

            let loadedCount = 0;
            const totalImages = images.length;

            images.forEach(src => {
                if (imagesRef.current[src]) {
                    loadedCount++;
                    if (loadedCount === totalImages) {
                        setImagesLoaded(true);
                    }
                } else {
                    const img = new Image();
                    img.onload = () => {
                        loadedCount++;
                        imagesRef.current[src] = true;
                        if (loadedCount === totalImages) {
                            setImagesLoaded(true);
                        }
                    };
                    img.onerror = () => {
                        loadedCount++;
                        if (loadedCount === totalImages) {
                            setImagesLoaded(true);
                        }
                    };
                    img.src = src;
                }
            });
        };

        preloadImages();
    }, []);

    useEffect(() => {
        if (isOpen) {
            setIsRendered(true);
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen && isRendered) {
            const timer = setTimeout(() => {
                setIsRendered(false);
            }, 500); //delay to make sure it compeltes

            return () => clearTimeout(timer);
        }
    }, [isOpen, isRendered]);

    const handleDashboardClick = () => {
        onOverlayClick();
        if (isQaReviewInProgress) {
            requestLeaveQaReviewConfirmation(() => navigate('/'));
            return;
        }
        navigate('/');
    };
    const handleLiveControlClick = () => {
        onOverlayClick();
        if (isQaReviewInProgress) {
            requestLeaveQaReviewConfirmation(() => navigate(`/live-control`));
            return;
        }
        navigate(`/live-control`);
    };
    const handleRoboticDataClick = () => {
        if (!canAccessRoboticData) {
            showNotification?.('info', 'Coming soon.');
            onOverlayClick();
            return;
        }
        onOverlayClick();
        if (isQaReviewInProgress) {
            requestLeaveQaReviewConfirmation(() => navigate('/robotic-data'));
            return;
        }
        navigate('/robotic-data');
    };
    const handleWhitepaperClick = () => {
        onOverlayClick();
        if (isQaReviewInProgress) {
            requestLeaveQaReviewConfirmation(() => navigate('/whitepaper'));
            return;
        }
        navigate('/whitepaper');
    };

    // const handleFleetClick = () => {
    //     onOverlayClick();
    //     if (isQaReviewInProgress) {
    //         requestLeaveQaReviewConfirmation(() => navigate('/fleet'));
    //         return;
    //     }
    //     navigate('/fleet');
    // };

    const handleDataClick = () => {
        onOverlayClick();
        if (isQaReviewInProgress) {
            requestLeaveQaReviewConfirmation(() => navigate('/data/upload'));
            return;
        }
        navigate('/data/upload');
    };
    const handleVlaFoundryClick = () => {
        handleDataClick();
    };

    const handleAccountClick = () => {
        onOverlayClick();
        if (isQaReviewInProgress) {
            requestLeaveQaReviewConfirmation(() => navigate('/account'));
            return;
        }
        navigate('/account');
    };

    if (!isOpen && !isRendered) {
        return null;
    }

    const menuContainerClass = `${styles.sideMenuContainer} ${isOpen ? styles.open : ''} ${imagesLoaded ? styles.imagesLoaded : ''}`;

    return (
        <>
            <div
                className={menuContainerClass}
                onClick={stopPropagation}
            >
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    height: '32px',
                    width: '100%',
                    marginBottom: '32px'
                }}>
                    <img
                        src={logo_svg}
                        style={{height: '34px', marginLeft: "8px", cursor: 'pointer'}}
                        alt="PrismaXAI"
                        onClick={() => window.open('https://prismax.ai/', '_blank')}
                    />
                    <button className={styles.closeButton} onClick={onOverlayClick}>
                        ✕
                    </button>
                </div>
                <div>
                    {/* Dashboard */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleDashboardClick}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                src={location.pathname === '/' ? transImgHover : transImg}
                                alt="Dashboard"
                            />
                        </div>
                        <span>Dashboard</span>

                    </div>

                    {/* Robotic Data: retained behind a feature switch for possible restoration. */}
                    {ROBOTIC_DATA_UI_ENABLED ? (
                        <div
                            className={`${styles.menuItem} ${
                                location.pathname.startsWith('/robotic-data') ? styles.selected : ''
                            } ${imagesLoaded ? styles.imageLoaded : ''}`}
                            onClick={handleRoboticDataClick}
                        >
                            <div className={styles.imageContainer}>
                                <img
                                    src={roboticDataImg}
                                    alt="Robotic Data"
                                />
                            </div>
                            <span>Robotic Data</span>
                            {!canAccessRoboticData && <span style={{marginLeft: 'auto', fontSize: '12px', color: '#666'}}>(Coming Soon)</span>}
                        </div>
                    ) : null}

                    {/* VLA Foundry */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname.startsWith('/data') ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleVlaFoundryClick}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                src={location.pathname.startsWith('/data') ? assetsImgHover : assetsImg}
                                alt="VLA Foundry icon"
                            />
                        </div>
                        <span>VLA Foundry</span>
                    </div>

                    {/* Live Control */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/live-control' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleLiveControlClick}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                src={liveControlImg}
                                alt="live-control"
                            />
                        </div>
                        <span>Live Control</span>
                    </div>

                    {/* Robot Fleet */}
                    {/* <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/fleet' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleFleetClick}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                src={location.pathname === '/fleet' ? assetsImgHover : assetsImg}
                                alt="Robot Fleet"
                            />
                        </div>
                        <span>Robot Fleet</span>
                    </div> */}

                    {/*/!* Dataset Library *!/*/}
                    {/*<div*/}
                    {/*    className={`${styles.menuItem} ${*/}
                    {/*        location.pathname === '/dataset' ? styles.selected : ''*/}
                    {/*    } ${imagesLoaded ? styles.imageLoaded : ''}`}*/}
                    {/*    onClick={handleDatasetClick}*/}
                    {/*>*/}
                    {/*    <div className={styles.imageContainer}>*/}
                    {/*        <img*/}
                    {/*            src={location.pathname === '/dataset' ? liveControlImgHover : liveControlImg}*/}
                    {/*            alt="Live Control"*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*    <span>Live Control</span>*/}
                    {/*    <span style={{marginLeft: 'auto', fontSize: '12px', color: '#666'}}>(Coming Soon)</span>*/}
                    {/*</div>*/}

                    {
                        <div className={styles.divider}></div>
                    }

                    {/* whitepaper */}
                    <div
                        className={`${styles.menuItem} ${styles.whitepaperItem} ${
                            location.pathname === '/whitepaper' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleWhitepaperClick}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                src={location.pathname === '/whitepaper' ? bookImgHover : bookImg}
                                alt="Whitepaper"
                            />
                        </div>
                        <span>Whitepaper</span>
                        {/*<span style={{marginLeft: 'auto', fontSize: '12px', color: '#666'}}>(Coming Soon)</span>*/}
                    </div>


                    {/* Account */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/account' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleAccountClick}
                        style={{
                            marginTop: '30px'
                        }}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                className={styles.account_logo}
                                src={userClass === 'Amplifier Member' ?
                                    badge_amplifier : (userClass === 'Innovator Member' ? badge_innovator : badge_explorer)}
                                alt="account icon"
                            />
                        </div>
                        <span>Account</span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SideMenu;
